export const HOME = "HOME";
export const SEARCH = "SEARCH";
export const SETTINGS = "SETTINGS";
export const TOPPADDING = "15vh";
export const BOTPADDING = "15vh";
export const TABICONSIZE = "30";
